import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import TimetableSyncSetup from "./routes/TimetableSyncSetup";
export default store => ({
  path: "timetable-sync",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-schoolSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [TimetableSyncSetup(store)],
});
